import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';

export default function useTimer(deadline) {
  const [timer, setTimer] = useState(0);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const [stoppedTimer, setStoppedTimer] = useState(false);

  const getTime = useCallback(() => {
    if (!deadline) return;

    let time = (Date.parse(new Date(deadline)) - Date.now()) / 1000;
    time += 3 * 60 * 60; // +3 horas

    if (time <= 0) {
      time = 0;
    }

    setTimer(time);
    setDays(
      Math.floor(time / (60 * 60 * 24))
        .toString()
        .padStart(2, '0')
    );
    setHours(
      Math.floor((time / (60 * 60)) % 24)
        .toString()
        .padStart(2, '0')
    );
    setMinutes(
      Math.floor((time / 60) % 60)
        .toString()
        .padStart(2, '0')
    );
    setSeconds(
      Math.floor(time % 60)
        .toString()
        .padStart(2, '0')
    );

    return time;
  }, [deadline]);
  useEffect(() => {
    const interval = setInterval(() => {
      const time = getTime();
      setStoppedTimer(time <= 0);
    }, 1000);

    if (deadline && stoppedTimer) clearInterval(interval);

    return () => clearInterval(interval);
  }, [deadline, getTime, stoppedTimer]);

  return { timer, days, hours, minutes, seconds, stoppedTimer };
}

useTimer.propTypes = {
  deadline: PropTypes.shape(PropTypes.object),
};
